import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './index.css';

import Navbar          from './components/Navbar';
import Footer          from './components/Footer';
import FloatingButtons from './components/FloatingButtons';  // ← ADD THIS

import Home          from './pages/Home';
import About         from './pages/About';
import PainMedicine  from './pages/PainMedicine';
import Orthopaedics  from './pages/Orthopaedics';
import Physiotherapy from './pages/Physiotherapy';
import Conditions    from './pages/Conditions';
import Doctors       from './pages/Doctors';
import Testimonials  from './pages/Testimonials';
import Contact       from './pages/Contact';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, [pathname]);
  return null;
}

function AppRoutes() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/"                          element={<Home />} />
          <Route path="/about"                     element={<About />} />
          <Route path="/treatments/pain-medicine"  element={<PainMedicine />} />
          <Route path="/treatments/orthopaedics"   element={<Orthopaedics />} />
          <Route path="/treatments/physiotherapy"  element={<Physiotherapy />} />
          <Route path="/conditions"                element={<Conditions />} />
          <Route path="/doctors"                   element={<Doctors />} />
          <Route path="/testimonials"              element={<Testimonials />} />
          <Route path="/contact"                   element={<Contact />} />
          <Route path="*" element={
            <div style={{textAlign:'center',padding:'160px 20px'}}>
              <div style={{fontSize:64,marginBottom:16}}>🏥</div>
              <h2 style={{fontSize:28,fontWeight:800,marginBottom:12}}>Page Not Found</h2>
              <a href="/" style={{display:'inline-flex',padding:'12px 28px',background:'#0D4E9A',color:'#fff',borderRadius:8,fontWeight:700,textDecoration:'none',marginTop:16}}>Go Home →</a>
            </div>
          } />
        </Routes>
      </main>
      <Footer />

      {/* ── FLOATING BUTTONS — shows on every page ── */}
      <FloatingButtons />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}